<div
    class="connections-card"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
    <h5>
        Connected Accounts
    </h5>
    <ul class="p-0 mb-0 mt-0 list-unstyled">
        <li class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <div class="icon">
                    <img src="images/socials/google.svg" alt="google">
                </div>
                <div class="title">
                    <span class="fw-semibold text-black d-block">
                        Google
                    </span>
                    <span class="d-block">
                        Calendar and Contacts
                    </span>
                </div>
            </div>
            <button class="p-0 bg-transparent border-0 transition text-primary">
                Click to Disconnect
            </button>
        </li>
        <li class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <div class="icon">
                    <img src="images/socials/slack.svg" alt="slack">
                </div>
                <div class="title">
                    <span class="fw-semibold text-black d-block">
                        Slack
                    </span>
                    <span class="d-block">
                        Communications
                    </span>
                </div>
            </div>
            <button class="p-0 bg-transparent border-0 transition text-primary">
                Click to Disconnect
            </button>
        </li>
        <li class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <div class="icon">
                    <img src="images/socials/github.svg" alt="github">
                </div>
                <div class="title">
                    <span class="fw-semibold text-black d-block">
                        GitHub
                    </span>
                    <span class="d-block">
                        Manage your Git repositories
                    </span>
                </div>
            </div>
            <button class="p-0 bg-transparent border-0 transition text-primary">
                Click to Disconnect
            </button>
        </li>
        <li class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <div class="icon">
                    <img src="images/socials/mailchimp.svg" alt="mailchimp">
                </div>
                <div class="title">
                    <span class="fw-semibold text-black d-block">
                        Mailchimp
                    </span>
                    <span class="d-block">
                        Email marketing service
                    </span>
                </div>
            </div>
            <button class="p-0 bg-transparent border-0 transition text-primary">
                Click to Disconnect
            </button>
        </li>
        <li class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <div class="icon">
                    <img src="images/socials/figma.svg" alt="figma">
                </div>
                <div class="title">
                    <span class="fw-semibold text-black d-block">
                        Figma
                    </span>
                    <span class="d-block">
                        Design
                    </span>
                </div>
            </div>
            <button class="p-0 bg-transparent border-0 transition text-primary">
                Click to Disconnect
            </button>
        </li>
    </ul>
    <div class="border-top"></div>
    <h5>
        Social Accounts
    </h5>
    <ul class="p-0 mb-0 mt-0 list-unstyled">
        <li class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <div class="icon">
                    <img src="images/socials/facebook.svg" alt="facebook">
                </div>
                <div class="title">
                    <span class="fw-semibold text-black d-block">
                        Facebook
                    </span>
                </div>
            </div>
            <button class="p-0 bg-transparent border-0 transition text-primary">
                Click to Disconnect
            </button>
        </li>
        <li class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <div class="icon">
                    <img src="images/socials/twitter.svg" alt="twitter">
                </div>
                <div class="title">
                    <span class="fw-semibold text-black d-block">
                        X
                    </span>
                </div>
            </div>
            <button class="p-0 bg-transparent border-0 transition text-primary">
                Click to Disconnect
            </button>
        </li>
        <li class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <div class="icon">
                    <img src="images/socials/instagram.svg" alt="instagram">
                </div>
                <div class="title">
                    <span class="fw-semibold text-black d-block">
                        Instagram
                    </span>
                </div>
            </div>
            <button class="p-0 bg-transparent border-0 transition text-body">
                Not Connected
            </button>
        </li>
        <li class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <div class="icon">
                    <img src="images/socials/dribbble.svg" alt="dribbble">
                </div>
                <div class="title">
                    <span class="fw-semibold text-black d-block">
                        Dribbble
                    </span>
                </div>
            </div>
            <button class="p-0 bg-transparent border-0 transition text-primary">
                Click to Disconnect
            </button>
        </li>
        <li class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <div class="icon">
                    <img src="images/socials/behance.svg" alt="behance">
                </div>
                <div class="title">
                    <span class="fw-semibold text-black d-block">
                        Behance
                    </span>
                </div>
            </div>
            <button class="p-0 bg-transparent border-0 transition text-primary">
                Click to Disconnect
            </button>
        </li>
    </ul>
</div>